import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";


function ChapterWisePYQPhyTopics() {



  return (
    <>

      <AllSubjectTopics  subject="physics" type="chapterwisepyq" />

    </>
  );
}

export default ChapterWisePYQPhyTopics; 